import { useQuery } from '@tanstack/react-query';

import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';
import { TeliaSegment } from '@telialt/utils/src/segment';

import { SEARCH_QUERY_KEYS } from '../constants';
import { SearchFilters } from '../model';
import { loadCategoryProductsResults } from './DataLoading/LoadCategoryProductsResults';
import { useLoadQueryKeys } from './useLoadQueryKeys';

type Params = {
    productIds: string[];
    segment: TeliaSegment;
    isEnabled?: boolean;
};

export const useLoadCompareProducts = ({ productIds, segment, isEnabled }: Params) => {
    const { isLoading: isQueryKeysLoading, queryKeys } = useLoadQueryKeys(isEnabled);

    const {
        data,
        isFetching: isResultsLoading,
        error,
    } = useQuery({
        queryKey: [SEARCH_QUERY_KEYS.SEARCH_RESULTS_COMPARE_PRODUCTS, segment, productIds],
        queryFn: async ({ signal }) => {
            const filters: SearchFilters = {
                id: productIds,
            };

            return loadCategoryProductsResults({
                segment,
                queryKeys,
                filters,
                signal,
            });
        },
        enabled: !!queryKeys && isEnabled,
    });
    useLogError(error, DDComponent.Search);

    return { isLoading: isQueryKeysLoading || isResultsLoading, error, data };
};
